import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SystemMessageBuilder from "../../../core/system-message/controller/SystemMessageBuilder";
import SessionModel from "../../session/model/SessionModel";
import BackendErrorEvent from "../event/BackendErrorEvent";

export default class BackendErrorCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher
     * @param {SessionModel} sessionModel
     * @param {RevisableLanguagePack} languagePack
     */
    constructor(dispatcher, sessionModel, languagePack) {
        super(dispatcher);

        this._sessionModel = sessionModel;
        this._languagePack = languagePack;
    }

    execute(evt) {
        /** @type {BackendErrorEvent} */
        const data = evt.params.data;
        const { type, error, failSilently } = data;

        if (failSilently) {
            return;
        }

        switch (type) {
            case BackendErrorEvent.CONTENT_FILTER_VIOLATION:
                this._handleContentFilterViolation(error);
                break;
            case BackendErrorEvent.ERROR:
                this._handleError(error);
                break;
            default:
                console.error(`[${BackendErrorCommand.name}] unhandled type `, type, error);
                break;
        }
    }

    _handleContentFilterViolation(error) {
        const systemMessage = new SystemMessageBuilder()
            .setTitle(this._languagePack.getText(`backendErrors.contentFilterViolation.title`))
            .setDescription(`${this._languagePack.getText(`backendErrors.contentFilterViolation.description`)}\n\nSession: ${this._sessionModel.sessionId}\nError: ${error.message}`)
            .addOption({
                text: this._languagePack.getText(`backendErrors.contentFilterViolation.closeButtonLabel`),
            })
            .build();
        this.showSystemMessage(systemMessage);
    }

    _handleError(error) {
        const systemMessage = new SystemMessageBuilder()
            .setTitle(this._languagePack.getText(`backendErrors.genericError.title`))
            .setDescription(`${this._languagePack.getText(`backendErrors.genericError.description`)}\n\nSession: ${this._sessionModel.sessionId}\nError: ${error.message}`)
            .addOption({
                text: this._languagePack.getText(`backendErrors.genericError.closeButtonLabel`),
            })
            .build();
        this.showSystemMessage(systemMessage);
    }
}